/**
 * O botão de contorno bege das barras de Lançamentos e de Cadastros.
 *
 * Papel: reproduz `.btn-action` e `.nav-action` (l. 43–44, 51–52) — 28 px de
 * altura, Outfit 11 px em caixa alta com `.08em`, texto e borda bege e, sob o
 * ponteiro, o texto em latão escuro sobre `--superficie-2`. É o "Novo
 * Lançamento", o "Exportar XLSX", o "Nova Categoria" e os atalhos de período.
 *
 * Como usar: os atalhos de período ("Hoje", "Mês Atual", as setas) são
 * `.nav-action`, que é o mesmo desenho com `margin:auto 2px`, e passam
 * `navegacao`. O ícone entra como primeiro filho, em 13 px, e ganha à direita o
 * `.08em` do espaçamento entre letras, que a origem aplica ao caractere da fonte
 * de ícones e o SVG não recebe; as setas de chevron passam `className="px-2"`,
 * o `padding:0 8px` da origem.
 */
import { type ComponentProps } from 'react';

import { cn } from '@/shared/lib/utils';

interface BotaoDeAcaoProps extends ComponentProps<'button'> {
  /** Verdadeiro nos atalhos de período, o `.nav-action` da origem. */
  navegacao?: boolean;
}

/**
 * Um botão de ação.
 *
 * @param navegacao - Verdadeiro para o respiro de `.nav-action`.
 * @param className - Classes de quem chama, aplicadas por último pelo `cn()`.
 * @param type - O `type` do botão; `button` quando ausente.
 * @returns O botão.
 */
export function BotaoDeAcao({
  navegacao = false,
  className,
  type = 'button',
  ...props
}: BotaoDeAcaoProps) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex h-7 cursor-pointer items-center gap-[5px] rounded-[5px] border border-emb-acao-borda bg-superficie px-3 font-outfit text-[11px] font-normal tracking-[0.08em] whitespace-nowrap text-emb-acao uppercase transition-all duration-150 hover:border-emb-acao-borda-hover hover:bg-superficie-2 hover:text-brass-light [&>svg]:mr-[0.08em]',
        navegacao && 'mx-0.5 my-auto',
        className,
      )}
      {...props}
    />
  );
}
